import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "count-favorites"
}

import { onMounted, onUnmounted, reactive, watch } from "vue";
  import Api from "@/services/api";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { useToast } from "primevue/usetoast";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FavoriteButton',
  props: {
    lotIdProp: {},
    subscribersCountProp: { default: 0 },
    showCount: { type: Boolean, default: false }
  },
  emits: ["countChange"],
  setup(__props: any, { emit: __emit }) {

  const auctionStore = useAuctionStore();
  const toast = useToast();

  const props = __props;

  const emit = __emit;

  const state = reactive({
    lotId: props.lotIdProp,
    inWishlist: auctionStore.user?.favorite_lots?.includes(props.lotIdProp) || false,
    subscribersCount: props.subscribersCountProp
  });

  watch(
    () => state.subscribersCount,
    (val) => {
      emit("countChange", val);
    },
    { immediate: true }
  );

  watch(
    () => auctionStore.user?.favorite_lots,
    (nv, ov) => {
      state.inWishlist = auctionStore.user?.favorite_lots?.includes(props.lotIdProp) || false;
    },
    { deep: true }
  );

  watch(
    () => props.subscribersCountProp,
    (val) => {
      state.subscribersCount = val || 0;
    }
  );

  watch(
    () => props.lotIdProp,
    (val, oldVal) => {
      state.lotId = val;
      state.inWishlist = auctionStore.user?.favorite_lots?.includes(val) || false;

      if (props.showCount) {
        if (oldVal) {
          unsubscribe(oldVal);
        }
        subscribe();
      }
    }
  );

  onMounted(() => {
    if (props.showCount) {
      subscribe();
    }
  });

  onUnmounted(() => {
    unsubscribe(state.lotId);
  });

  const subscribe = () => {
    window.Echo.channel(`lots.${props.lotIdProp}.favorite.count`).listen(
      ".changed",
      (e: { lotId: number; count: number }) => {
        state.subscribersCount = e.count || 0;
      }
    );
  };

  const unsubscribe = (lotId: number) => {
    if (props.showCount && lotId) {
      window.Echo.leave(`lots.${lotId}.favorite.count`);
    }
  };

  const toggleFavorite = (event: Event) => {
    event.stopPropagation();

    if (auctionStore.user?.id) {
      Api.post("/api/lots/" + state.lotId + "/toggle-favorite").catch((error) => {
        console.log(error);
      });
    } else {
      toast.add({
        severity: "warn",
        summary: trans("live.modals.auth_favorite.header"),
        detail: trans("live.modals.auth_favorite.message"),
        life: 6000
      });
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["favorite-btn", { 'in-wishlist': state.inWishlist }]),
    onClick: toggleFavorite
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("svg", { class: "icon-star" }, [
      _createElementVNode("use", {
        class: "default",
        href: "/sprite.svg#star"
      }),
      _createElementVNode("use", {
        class: "hover",
        href: "/sprite.svg#star-fill"
      })
    ], -1)),
    (props.showCount)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(state.subscribersCount), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})